import styled from "styled-components";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

export const StyledHorizontalSplit = styled.div<{ background?: string; marginTop?: number; marginBottom?: number }>`
    background: ${(props) => props.background || UIStyleConstants.GRAY_DARK_COLOR};
    width: 100%;
    height: 1px;
    opacity: 0.2;

    margin: ${(props) => props.marginTop || 0}px 0 ${(props) => props.marginBottom || 0}px;
`;
